/* Adapter only: submission, request, spinner, cart rendering and checkout remain Shrine-native. */
(() => {
  if (window.YellowMaskLanding) return;
  window.YellowMaskLanding = true;
  const bindings = new WeakMap();
  const selector = '[data-ym-buybox]';
  function primary() { return document.querySelector(selector); }
  function nativeButton() { return primary()?.querySelector('product-form button[type="submit"]'); }
  function init(root = document) {
    const boxes = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) boxes.push(root);
    boxes.forEach(box => {
      if (bindings.has(box)) return;
      const formElement = box.querySelector('product-form');
      const form = formElement?.querySelector('form');
      const button = formElement?.querySelector('[type="submit"]');
      if (!form || !button) return;
      const variants = JSON.parse(box.querySelector('[data-ym-variants]').textContent);
      const currency = JSON.parse(box.querySelector('[data-ym-currency]').textContent);
      // Mirrors the active Shopify automatic discount: $9.99 once, minimum two ski masks.
      const maskIds = new Set(['59978503192960','59978503225728','59978503258496','59978503291264']);
      const duoDiscount = currency === 'USD' && variants.length > 0 && variants.every(v => maskIds.has(String(v.id))) ? 999 : 0;
      const packs = [...box.querySelectorAll('[data-ym-pack]')];
      const pickers = [...box.querySelectorAll('[data-ym-variant]')];
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(amount / 100);
      let count = packs.length && box.dataset.defaultPack === '2' ? 2 : 1;
      const error = box.querySelector('[data-ym-error]');
      function chosen(index) {
        const id = pickers[index]?.value || form.querySelector('[name="id"]')?.value;
        return variants.find(v => String(v.id) === String(id));
      }
      function sync() {
        const selected = Array.from({length:count},(_,i)=>chosen(i));
        const available = selected.every(v=>v?.available);
        const total = Math.max(0, selected.reduce((sum,v)=>sum+(v?.price || 0),0) - (count === 2 ? duoDiscount : 0));
        const compare = selected.reduce((sum,v)=>sum+Math.max(v?.compare || 0,v?.price || 0),0);
        packs.forEach(p=>p.setAttribute('aria-pressed',String(Number(p.dataset.ymPack)===count)));
        const activeCard=box.querySelector('[data-ym-pack-card="'+count+'"]');
        const pickerGroup=box.querySelector('.ym-pickers');
        box.querySelectorAll('[data-ym-pack-card]').forEach(card=>card.classList.toggle('ym-selected',card===activeCard));
        if(activeCard && pickerGroup && pickerGroup.parentElement!==activeCard)activeCard.append(pickerGroup);
        const second = box.querySelector('[data-ym-picker-row="2"]');
        if (second) second.hidden=count===1;
        const price = box.querySelector('[data-ym-price]');
        if (price) price.textContent=money(total);
        const compared = box.querySelector('[data-ym-compare]');
        if (compared) { compared.textContent=money(compare); compared.hidden=compare<=total; }
        const solo=box.querySelector('[data-ym-solo-price]'),duo=box.querySelector('[data-ym-duo-price]');
        if(solo)solo.textContent=money(chosen(0)?.price || 0);
        if(duo)duo.textContent=money(Math.max(0,(chosen(0)?.price || 0)+(chosen(1)?.price || 0)-duoDiscount));
        const items=[];
        selected.filter(Boolean).forEach(v=>{const item=items.find(i=>i.id===String(v.id));if(item)item.quantity++;else items.push({id:String(v.id),quantity:1});});
        // Existing Shrine ProductForm.handleSubmit reads bundleDeals.formVariants,
        // creates items[n] inputs, and invokes its own cart render/animation path.
        formElement.bundleDeals = {formVariants:items};
        const input=form.querySelector('[name="id"]');
        if(input && selected[0]) input.value=selected[0].id;
        if(!button.classList.contains('loading')) {
          button.disabled=!available;
          if(available)button.removeAttribute('aria-disabled');
        }
        let label=button.querySelector('.main-atc__label__text');
        if(!label && button.querySelector('.main-atc__label')) {
          const wrapper=button.querySelector('.main-atc__label');
          wrapper.textContent='';label=document.createElement('span');label.className='main-atc__label__text';
          label.textContent=formElement.dataset.ymCtaLabel || window.variantStrings?.addToCart || 'Add to cart';wrapper.append(label);
        }
        if(label){if(!label.dataset.ymOriginal)label.dataset.ymOriginal=label.textContent;label.textContent=available?label.dataset.ymOriginal:(window.variantStrings?.soldOut || box.dataset.unavailable);}
        const inlinePrice=button.querySelector('[id^="main-atc-price-"]');
        if(inlinePrice)inlinePrice.textContent=box.dataset.showPrice==='true'?money(total)+' • ':'';
        error.hidden=available;
        if(!available)error.textContent=box.dataset.unavailable;
        document.querySelectorAll('[data-ym-total]').forEach(el=>el.textContent=money(total));
        document.querySelectorAll('[data-ym-add]').forEach(el=>el.disabled=!available);
        document.dispatchEvent(new CustomEvent('ym:variant',{detail:selected[0] || {}}));
        return available;
      }
      packs.forEach(p=>p.addEventListener('click',()=>{count=Number(p.dataset.ymPack);sync();}));
      pickers.forEach(p=>p.addEventListener('change',sync));
      form.addEventListener('submit',event=>{
        if(!sync()){event.preventDefault();event.stopImmediatePropagation();error.focus();}
      },true);
      bindings.set(box,{sync});
      sync();
      if(window.customElements)customElements.whenDefined('product-form').then(()=>{
        if(!box.isConnected)return;
        sync();
        // Shopify multi-item responses return items[]. Notification expects one key.
        // Retain its own renderer and animation, adapting only that response shape.
        const cart=formElement.cart;
        if(cart?.tagName==='CART-NOTIFICATION' && !cart.ymMultiItemAdapter){
          const original=cart.renderContents.bind(cart);
          cart.renderContents=function(state,...args){
            if(!state.key && state.items?.length)state={...state,...state.items[0],sections:state.sections};
            return original(state,...args);
          };
          cart.ymMultiItemAdapter=true;
        }
      });
    });
    root.querySelectorAll('[data-ym-gallery]').forEach(gallery=>{
      if(gallery.dataset.ymReady)return;
      gallery.dataset.ymReady='true';
      const track=gallery.querySelector('[data-ym-slides]');
      const buttons=[...gallery.querySelectorAll('[data-ym-slide]')];
      const move=i=>track.scrollTo({left:Math.max(0,Math.min(track.children.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      buttons.forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.ymSlide))));
      gallery.querySelector('[data-ym-prev]')?.addEventListener('click',()=>move(Math.round(track.scrollLeft/track.clientWidth)-1));
      gallery.querySelector('[data-ym-next]')?.addEventListener('click',()=>move(Math.round(track.scrollLeft/track.clientWidth)+1));
      track.addEventListener('scroll',()=>buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===Math.round(track.scrollLeft/track.clientWidth)))),{passive:true});
      if(buttons[0])buttons[0].setAttribute('aria-current','true');
    });
    const box=primary();if(box)bindings.get(box)?.sync();
    refreshSticky();
  }
  function refreshSticky(){
    const button=nativeButton();
    document.querySelectorAll('[data-ym-sticky]').forEach(bar=>{
      bar.classList.toggle('ym-visible',!!button && button.getBoundingClientRect().bottom<0);
    });
  }
  document.addEventListener('click',event=>{
    const proxy=event.target.closest('[data-ym-add]');
    if(!proxy)return;
    const box=primary(),button=nativeButton();
    if(!box || !button)return;
    if(!bindings.get(box)?.sync() || button.disabled){box.scrollIntoView({behavior:'smooth',block:'center'});return;}
    if(button.getAttribute('aria-disabled')==='true' || button.classList.contains('loading'))return;
    button.click();
  });
  document.addEventListener('ym:variant',event=>{
    if(!event.detail.mid)return;
    document.querySelectorAll('[data-ym-slides]').forEach(track=>{
      const index=[...track.children].findIndex(s=>s.dataset.mediaId===String(event.detail.mid));
      if(index>=0)track.scrollTo({left:index*track.clientWidth,behavior:'smooth'});
    });
  });
  window.addEventListener('scroll',refreshSticky,{passive:true});
  window.addEventListener('resize',refreshSticky);
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:reorder',()=>init());
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(refreshSticky));
  document.addEventListener('shopify:block:select',e=>{
    const slide=e.target.closest('.ym-slide');
    if(slide)slide.parentElement.scrollTo({left:slide.offsetLeft-slide.parentElement.offsetLeft,behavior:'smooth'});
    const details=e.target.closest('details.ym-faq');if(details)details.open=true;
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();
